import React from 'react';
import classNames from 'classnames';
import { Box, BoxProps, Grid, Tooltip } from '@material-ui/core';
import css from './styles.module.scss';
import AudioPlayer from 'material-ui-audio-player';
import { makeStyles } from '@material-ui/styles';
import PlayArrow from '@material-ui/icons/PlayArrow';
import Pause from '@material-ui/icons/Pause';
import { VerticalPopver } from '~/features/dashboard/components/vertical-popover';

type SongPlayerProps = BoxProps & {
    song: {
        gSongFileName: string;
        gSongFilePath: string;
    };
    editBtn: boolean;
    deleteAssetsBtn: (data: any) => void;
    editAssetsBtn: (data: any) => void;
};

const useStyles = makeStyles(() => {
    return {
        root: {
            flexGrow: 1,
            borderRadius: '8px',
            margin: 'auto',
            '& > *': {
                display: 'flex',
                alignItems: 'center',
            },
            paddingLeft: '12px',
            '& > :nth-child(3)': {
                order: 1,
            },
        },
        playIcon: {
            fontSize: '1.5rem',
        },
        replayIcon: {
            fontSize: '1.5rem',
        },
        pauseIcon: {
            fontSize: '1.5rem',
        },
        volumeIcon: {
            fontSize: '1.5rem',
        },
    };
});

export const SongPlayer: React.FC<SongPlayerProps> = ({ song, editBtn, className, deleteAssetsBtn, editAssetsBtn, ...props }) => {
    const icons = {
        PlayIcon: PlayArrow,
        PauseIcon: Pause,
    };

    return (
        <Tooltip title={song.gSongFileName} placement="top">
            <Box className={classNames(css.module, className)} {...props}>
                <Grid container>
                    <AudioPlayer
                        elevation={0}
                        spacing={1}
                        useStyles={useStyles}
                        src={song.gSongFilePath}
                        displaySlider={true}
                        timePosition="start"
                        icons={icons}
                    />
                </Grid>
                <VerticalPopver
                    childClassName={css.icon}
                    editAction={editBtn ? () => editAssetsBtn(song) : undefined}
                    deleteAction={() => deleteAssetsBtn(song)}
                />
            </Box>
        </Tooltip>
    );
};
